import { render, staticRenderFns } from "./AdminLand.vue?vue&type=template&id=5083cc8a&"
import script from "./AdminLand.vue?vue&type=script&lang=js&"
export * from "./AdminLand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports